import PropTypes from "prop-types";
import { useNavigate, useLocation } from "react-router-dom";

import "./logo.scss";

const Logo = ({ onNavigateAway }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleNavigateLogo = () => {
    onNavigateAway && pathname !== "/proposals"
      ? onNavigateAway()
      : navigate("/");
  };

  return (
    <button className="logo" aria-label="Remi" onClick={handleNavigateLogo}>
      <i className="icon logo__icon" aria-hidden="true" />
    </button>
  );
};

Logo.propTypes = {
  onNavigateAway: PropTypes.func,
};

export default Logo;
